import { AlertStatus } from '@/task-manager/entities/alert-status';
import type { AlertSuggestion } from '@/task-manager/entities/alert-suggestion';

import type { ListCardsViewOutputSuggestions } from '../fetch-client';

import { alertLevelMapper } from './alert-level';
import { alertStatusMapper } from './alert-status';
import { alertTypeMapper } from './alert-type';

export function alertSuggestionMapper(
  data: ListCardsViewOutputSuggestions,
): AlertSuggestion {
  return {
    id: data.finding_id,
    accureId: data.accure_id,
    frontendId: data.frontend_id,
    level: data.level ? alertLevelMapper(data.level) : undefined,
    status: alertStatusMapper(data.status) ?? AlertStatus.INFO,
    suggestedAction: data.suggested_action,
    changedAt: new Date(data.status_changed_date),
    type: alertTypeMapper(data.alert_type),
  };
}
